import ArticleItemCover from '@/cmsComponents/ArticleItemCover';
import { PATH } from 'constants/path';
import Link from 'next/link';
import React from 'react';
import { IArticleSummary } from 'types/cms';

import Grid from '@material-ui/core/Grid';

import styles from './style.module.scss';

interface IProps {
  articles: Array<IArticleSummary>;
}

export const FeaturedArticleSection: React.FC<IProps> = ({ articles }) => {
  const [first, ...rest] = articles;
  return (
    <Grid container spacing={3} className={styles.container}>
      {first && (
        <Grid item md={7} xs={12}>
          <ArticleItemCover article={first} />
        </Grid>
      )}
      <Grid item md={5} xs={12}>
        <h2 className={styles.componentsTitle}>Recent stories</h2>
        <ul className={styles.list}>
          {rest.map(
            (i, index) =>
              index <= 3 && (
                <li key={i.id}>
                  {i.article_category?.name && (
                    <span className={styles.category}>{i.article_category?.name}</span>
                  )}
                  <Link
                    prefetch={false}
                    href={`${PATH.ARTICLES}/${i.slug}`}
                    as={`${PATH.ARTICLES}/${i.slug}`}
                  >
                    <a title={i.title}>{i.title}</a>
                  </Link>
                </li>
              ),
          )}
        </ul>
      </Grid>
    </Grid>
  );
};
